import { type FC } from "react";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  FilterOutlined,
  SearchOutlined,
  VerticalAlignMiddleOutlined,
} from "@ant-design/icons";

export interface TableHeaderCellProps {
  label: string;
  unit: string;
  classPrefix: string;
  columnClassName: string;
  // The sort/filter/search/align icon cluster is decorative chrome from the
  // original seed-rate table design; the plain-header table variants (e.g.
  // the auto-assignment plot table) don't show it at all.
  showIcons?: boolean;
}

const TableHeaderCell: FC<TableHeaderCellProps> = ({
  label,
  unit,
  classPrefix,
  columnClassName,
  showIcons = true,
}) => (
  <div
    className={`${classPrefix}__header-cell ${columnClassName}`}
    role="columnheader"
  >
    {showIcons && (
      <ArrowDownOutlined className={`${classPrefix}__sort-icon`} aria-hidden />
    )}
    <span className={`${classPrefix}__header-label`}>{label}</span>
    {unit && <span className={`${classPrefix}__header-unit`}>{unit}</span>}
    {showIcons && (
      <>
        <span className={`${classPrefix}__header-actions`}>
          <VerticalAlignMiddleOutlined
            className={`${classPrefix}__action-icon`}
            aria-hidden
          />
          <FilterOutlined
            className={`${classPrefix}__action-icon`}
            aria-hidden
          />
          <SearchOutlined
            className={`${classPrefix}__action-icon`}
            aria-hidden
          />
        </span>
        <ArrowUpOutlined className={`${classPrefix}__sort-icon`} aria-hidden />
      </>
    )}
  </div>
);

export default TableHeaderCell;
